<template>
  <Page>
    <SidePageColumn side="left">
      <v-list shaped dense max-width="98.5%" class="grey lighten-5">
        <v-subheader class="pl-5">Manage Items Toolbar</v-subheader>
        <v-list-item-group color="primary" class="pl-3">
          <SideMenuItem
            v-for="(menu_item, index) in admin_menu_objects"
            :key="index"
            :to="menu_item.to"
            :icon="menu_item.icon"
            :label="menu_item.label"
            :badge_value="menu_item.badge_value ? menu_item.badge_value : 0"
          ></SideMenuItem>
        </v-list-item-group>
      </v-list>
    </SidePageColumn>
    <CenterPageColumn :has_nav_bar="true">
      <router-view
        :user="user"
        :is_loading="is_loading"
        @on-show-loader="$emit('on-show-loader')"
        @on-hide-loader="$emit('on-hide-loader')"
      ></router-view>
      <Footer
        :is_loading="is_loading"
        @on-hide-loader="$emit('on-hide-loader')"
        @on-show-loader="$emit('on-show-loader')"
      ></Footer>
    </CenterPageColumn>
  </Page>
</template>
<script>
import Page from "./../../components/Page";
import SidePageColumn from "./../../components/SidePageColumn";
import NavbarMenuItem from "../../components/NavbarMenuItem";
import SideMenuItem from "../../components/SideMenuItem";
import ServerClient from "../../lib/ServerClient";
import Utils from "../../lib/Utils";
import CenterPageColumn from "./../../components/CenterPageColumn";
import Footer from "./../../components/CenterFooter";
export default {
  name: "Admin",
  components: {
    Page,
    NavbarMenuItem,
    SideMenuItem,
    SidePageColumn,
    CenterPageColumn,
    Footer,
  },
  props: {
    is_loading: {
      type: Boolean,
      default: false,
    },
  },
  data: () => {
    return {
      admin_menu_objects: [
        {
          label: "Dashboard",
          icon: "mdi-home-city-outline",
          to: "/admin/dashboard",
          roles: ["super role", "backofficcee"],
        },
        {
          label: "Promotions",
          icon: "mdi-home-city-outline",
          to: "/admin/promotions",
          roles: ["super role", "backofficcee"],
        },
        {
          label: "Businesses",
          icon: "mdi-home-city-outline",
          to: "/admin/businesses",
          roles: ["super role", "backofficcee"],
        },
        {
          ky: "missing_info",
          badge_value: 0,
          label: "Missing Info ",
          icon: "mdi-home-city-outline",
          to: "/admin/missing",
          roles: ["owner"],
        },
        {
          label: "Categories",
          icon: "mdi-home-city-outline",
          to: "/admin/categories",
          roles: ["super role", "backofficcee"],
        },
        {
          label: "Locations",
          icon: "mdi-home-city-outline",
          to: "/admin/locations",
          roles: ["super role", "backofficcee"],
        },
        {
          label: "Hollidays",
          icon: "mdi-home-city-outline",
          to: "/admin/hollidays",
          roles: ["super role", "backofficcee"],
        },
        {
          label: "News Letters",
          icon: "mdi-home-city-outline",
          to: "/admin/new_letters",
          roles: ["super role", "backofficcee"],
        },
        {
          label: "Contact Messages",
          icon: "mdi-home-city-outline",
          to: "/admin/contact_us_messages",
          roles: ["super role", "backofficcee"],
        },
        {
          label: "Sliders",
          icon: "mdi-home-city-outline",
          to: "/admin/sliders",
          roles: ["super role", "backofficcee"],
        },
        {
          label: "Adverts",
          icon: "mdi-home-city-outline",
          to: "/admin/adverts",
          roles: ["super role", "backofficcee"],
        },
        {
          label: "Reports",
          icon: "mdi-home-city-outline",
          to: "/admin/reports",
          roles: ["super role", "backofficcee"],
        },
        {
          label: "users",
          icon: "mdi-home-city-outline",
          to: "/admin/users",
          roles: ["super role", "backofficcee"],
        }
      ],
      user: null,
    };
  },
  methods: {
    can_access(menu_item) {
      var res = Utils.can_access(this.user, menu_item);
      return res;
    },
    on_set_missing_badge_count(val) {
      //set the count to the menu items
      var temp = [];
      for (var index = 0; index < this.admin_menu_objects.length; index++) {
        var mo = this.admin_menu_objects[index];
        if (mo.ky && mo.ky == "missing_info") {
          mo.badge_value = val;
        }
        temp.push(mo);
      }
      this.admin_menu_objects = temp;
    },
    load_missing_info_badge_value() {
      ServerClient.Businesses.get_admin_missing_info_report(
        {
          user_id: this.user.id,
        },
        (res) => {
          //console.log("res: ", res);
          var items = Utils.scan_businesses_missing_info(
            res.businesses,
            res.hollidays
          );
          // console.log("resting: ", items.length);
          this.on_set_missing_badge_count(items.length);
        },
        (errors) => {
          console.log(
            "Errors while loading badge value for missing info on admin master page",
            errors
          );
        }
      );
    },
  },
  mounted() {
    this.user = ServerClient.Login.get_logged_in_user();
    this.load_missing_info_badge_value();
    if (this.$route.path == "/admin" || this.$route.path == "/admin/" ) {
      //redirect to dashboard
      this.$router.push("/admin/dashboard");
    }
  },
};
</script>